<div class="content mat-typography" [formGroup]="formGroup">
    <div class="form">
        <!-- <div class="image-container">
            <img src="assets/svg/my_rubric_logo_05.svg" alt="my rubic logo" />
        </div> -->
        <div
            class="title"
            style="padding-top: 2px; padding-bottom: 20px;"
        >
            {{ "cancelation_title"| translate }}
        </div>
        <div class="cancelation-subtitle">
            {{ "cancelation_subtitle" | translate }}
        </div>
        <p class="subtitle">
            {{ "cancelation_title_description" | translate }}
        </p>
        <p class="description">
            {{ "cancelation_description" | translate }}
        </p>
        <mat-form-field class="low-density">
            <textarea
                required
                matInput
                formControlName="reason"
            ></textarea>
            <ng-container *ngIf="formGroup.controls['reason'] as frmCtrl">
                <ng-container *ngIf=" frmCtrl.dirty || frmCtrl.touched">
                    <mat-error
                        *ngFor="let err of frmCtrl.errors | keyvalue"
                    >
                        {{ err.key | translate }}
                    </mat-error>
                </ng-container>
            </ng-container>
        </mat-form-field>
    </div>    
    <div class="footer">
        <button
            mat-raised-button
            color="primary"
            (click)="close()"
        >
            {{ "close" | translate }}
        </button>
        <button
            mat-raised-button
            color="primary"
            (click)="action()"
        >
            {{ "send" | translate }}
        </button>
    </div>
</div>
